import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  // Attributes are automatically handled by Mirage, so we don't need to define them here

  // Relationships
  floor: belongsTo('floor'),
  draft: belongsTo('draft'),
  neighborhood: belongsTo('neighborhood'),
  reservations: hasMany('reservation'),
  amenities: hasMany('amenity'),
  assignments: hasMany('assignment'),

  // You might want to add a parent desk relationship if needed
  parentDesk: belongsTo('desk', { inverse: null })
});
